var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 8,
  fill: "none",
  viewBox: "0 0 13 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.09.59 6.5 5.17 1.91.59.5 2l6 6 6-6z"
})));
export { SvgChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMS4wOSAwLjU4OTg0NEw2LjUgNS4xNjk4NEwxLjkxIDAuNTg5ODQ0TDAuNSAxLjk5OTg0TDYuNSA3Ljk5OTg0TDEyLjUgMS45OTk4NEwxMS4wOSAwLjU4OTg0NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";